import type { DemographicsCategory } from "./types";

export const AVAILABLE_TABS: DemographicsCategory[] = [
  "income",
  "population",
  "housing",
  "household",
  "education",
  "commute",
  "languages",
];
